import { Check } from "lucide-react"
import { ReactNode, RefObject } from "react"

import { Icon, IconSizes } from "../../../Icon"
import PopoverListItem, { PopoverListItemProps } from "../PopoverListItem"

interface PopoverSelectListItemProps
  extends Omit<PopoverListItemProps, "content"> {
  label: string
  accessory?: ReactNode
  content?: ReactNode
  isSelected: boolean
  ref?: RefObject<HTMLLIElement | null>
}

const PopoverSelectListItem = (props: PopoverSelectListItemProps) => {
  const { ref, content, label, accessory, isSelected, ...otherProps } = props

  return (
    <PopoverListItem {...otherProps} ref={ref}>
      {content ? (
        <div className="flex flex-1 items-center">{content}</div>
      ) : (
        <div className="flex flex-1 items-center gap-x-2 overflow-hidden">
          {accessory}
          <span className="truncate">{label}</span>
        </div>
      )}
      {isSelected && <Icon icon={Check} size={IconSizes.Small} />}
    </PopoverListItem>
  )
}

PopoverSelectListItem.displayName = "PopoverSelectListItem"

export default PopoverSelectListItem
